import { useContext, useEffect, useRef } from "react"
import { AuthContext } from "../../context/Auth/AuthContext"
import { SocketContext } from "../../context/Socket/SocketContext"
import { useUsuarioStore } from "../../stores/usuarioStore"
import { useDashboardStore } from "../../stores/dashboardStore"

const UserSocketInitializer = () => {
  const { user } = useContext(AuthContext)
  const socketManager = useContext(SocketContext)
  const oHandlerRef = useRef(null)

  useEffect(() => {
    if (!user?.id || !user?.companyId) return

    const nCompanyId = user.companyId
    const oSocket = socketManager.getSocket(nCompanyId)
    const cCanal = `company-${nCompanyId}-user`

    const oHandler = (oData) => {
      useUsuarioStore.getState().eventoSocketAplicar(oData)

      const lUsuarioInativado =
        oData?.action === "delete" ||
        (oData?.action === "update" && oData?.user && oData.user.ativo === false)

      if (lUsuarioInativado) {
        useDashboardStore.getState().invalidarTudo()
      }
    }
    oHandlerRef.current = oHandler

    oSocket.on(cCanal, oHandler)

    const oRawSocket = oSocket.io?.socket || oSocket
    const reconectarHandler = () => {
      if (oRawSocket?.recovered === false) {
        useUsuarioStore.getState().invalidarTudo()
      }
    }
    oRawSocket?.on?.("connect", reconectarHandler)

    return () => {
      oSocket.off(cCanal, oHandler)
      oRawSocket?.off?.("connect", reconectarHandler)
    }
  }, [socketManager, user?.id, user?.companyId])

  return null
}

export default UserSocketInitializer
